// extracted by mini-css-extract-plugin
export const posts = "posts-module--posts--n_83m";
export const post = "posts-module--post--3RkJd";
export const header = "posts-module--header--2grZG";
export const title = "posts-module--title--_vUMo";
export const date = "posts-module--date--3y8aY";
export const featureImage = "posts-module--featureImage--23OOS";
export const button = "posts-module--button--1NI9L";
export const metas = "posts-module--metas--3_Cya";